import { useFeatureFlag } from "@rdc-npm/rdc-app-context";

const featureFlagConfig = require("../api/config/featureFlag.config.js");

export const getAmplitudeFeatureFlags = () => {
  const { batchGetFeatures } = useFeatureFlag();
  const paidFlag =
    featureFlagConfig?.amplitudeFeatureFlag?.flags?.agentBrandingIsPaidFeatureEnabled;
  const flags = {
    isPaidFeatureFlagEnabled: paidFlag,
  };
  const versions = ["A", "B"];

  const featureFlags = Object.values(flags);
  const featureBatchVariables = batchGetFeatures?.(featureFlags) ?? {};
  const renamedFeatureFlags = {};

  Object.entries(flags).forEach(([flagKey, amplitudeKey]) => {
    const featureFlag = featureBatchVariables[amplitudeKey];
    if (!featureFlag) return;

    const { isEnabled, variation: flagVariation } = featureFlag;
    const variationValue = flagVariation?.toUpperCase?.();

    renamedFeatureFlags[flagKey] = !!(isEnabled && variationValue === "ON");

    versions.forEach((version) => {
      const versionedKey = flagKey.replace(
        "FeatureFlagEnabled",
        `Version${version}FeatureFlagEnabled`,
      );
      renamedFeatureFlags[versionedKey] = !!(isEnabled && variationValue === version);
    });
  });

  return renamedFeatureFlags;
};
